import React from "react";

interface FormNavigationProps {
  currentStep: number;
  totalSteps: number;
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
  isLastStep: boolean;
  className?: string;
  hideBackButton?: boolean;
  isSubmitting?: boolean;
}

export function FormNavigation({
  currentStep,
  totalSteps,
  onPrev,
  onNext,
  onSubmit,
  isLastStep,
  className = "",
  hideBackButton = false,
  isSubmitting = false,
}: FormNavigationProps) {
  const isFirstStep = currentStep === 1;

  return (
    <div className={`flex flex-col sm:flex-row justify-between gap-3 sm:gap-0 mt-6 sm:mt-8 ${className}`} role="navigation" aria-label="Navegação do formulário">
      {!hideBackButton && (
        <button
          type="button"
          onClick={onPrev}
          disabled={isFirstStep}
          aria-label={`Voltar para a etapa ${currentStep - 1}`}
          className={`w-full sm:w-auto px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg font-bold text-sm sm:text-base transition-all touch-manipulation ${
            isFirstStep
              ? "bg-gray-bb-4 text-gray-bb-2 cursor-not-allowed"
              : "bg-gray-bb-1 text-white-bb hover:bg-gray-bb-2 active:scale-95"
          }`}
        >
          VOLTAR
        </button>
      )}

      {!isLastStep ? (
        <button
          type="button"
          onClick={onNext}
          aria-label={`Avançar para a etapa ${currentStep + 1}`}
          className="w-full sm:w-auto bg-yellow-bb text-blue-bb-3 px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg font-bold text-sm sm:text-base hover:opacity-90 active:scale-95 transition-all touch-manipulation"
        >
          CONTINUAR
        </button>
      ) : (
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          aria-label="Finalizar inscrição"
          className={`w-full sm:w-auto bg-yellow-bb text-blue-bb-3 px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg font-bold text-sm sm:text-base transition-all touch-manipulation ${
            isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90 active:scale-95'
          }`}
        >
          {isSubmitting ? 'ENVIANDO...' : 'FINALIZAR'}
        </button>
      )}
    </div>
  );
}